import { FC } from "react"

export const AboutTab: FC = () => {
  return (
    <div className="flex flex-col items-start justify-center space-y-6 py-6 mx-auto max-w-sm w-full">
      <h1 className="w-full max-w-xs text-left text-black text-3xl font-semibold">
        About the Home Affordability Calculator App
      </h1>
      <a
        href="https://coherent.global/"
        target="_blank"
        rel="noreferrer"
        className="bg-brand-light text-white px-3 rounded h-10 leading-10"
      >
        LEARN MORE
      </a>
      <p>
        Coherent Spark instantly converts Excel into APIs so you can control, connect and comply across business logic.
        This app demonstrates just one example out of thousands of potential use cases. A home affordability calculator
        is a self-service tool anyone can use when shopping for a home or looking to refinance their existing mortgage.
        It is a broadly applicable, and can enhance your digital customer experience, all converted into code in seconds
        by Coherent Spark.
      </p>
      <img src="./excel-example-file.png" alt="Expected Losses Calculator Excel Example" />
      <p>
        Coherent Spark is a no-code SaaS platform that “API-ifies” Excel models for faster system integrations, product
        innovation, and return on investment in minutes, not months.
      </p>
      <p>
        This application was created by our business partner, Agilno in approximately one working day. It combines a
        custom React UI layer and a Model layer which contains the calculation logic that is developed in MS Excel and
        virtualized as an API using Coherent Spark.
      </p>
      <i>
        “If we were to create this demo without spark, we would need to involve at least 2 more engineers and it would
        take us 3 weeks more to create the same solution. Spark saved us over 120 engineering hours to produce this
        demo.”
      </i>
      <p>
        The result: a production-ready app in days—not weeks, not months. (And the actual models themselves can be
        converted in seconds, or just minutes for even complex models.)
      </p>
      <p className="font-semibold">
        To schedule a demo and test drive Spark, visit{" "}
        <a className="text-brand-light" href="https://coherent.global/" target="_blank" rel="noreferrer">
          coherent.global.
        </a>
      </p>
    </div>
  )
}

